import PagePlaceholder from '../components/PagePlaceholder.jsx';

export default function AdminSettings() {
  return (
    <PagePlaceholder
      title="Venue settings"
      note="Venue details, branding, tournament defaults, bank details."
    />
  );
}
